import { render } from "./MyTeamPage.vue?vue&type=template&id=9ae9b0ce&scoped=true"
import script from "./MyTeamPage.vue?vue&type=script&lang=js"
export * from "./MyTeamPage.vue?vue&type=script&lang=js"

import "./MyTeamPage.vue?vue&type=style&index=0&id=9ae9b0ce&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ae9b0ce"]])

export default __exports__